// @flow
export const csFormPageUrl = "/wechselservice/:categorySlug/abschließen";

export const csFormPageStormUrl = "/wechselservice/strom/abschließen";
export const csFormPageGasUrl = "/wechselservice/gas/abschließen";
